export let serverUrl = {}
// 设置的外部的auth 验证  http://47.100.35.236/nt_zrzy/app/bd/handler/BDHandler.ashx
// serverUrl.externalAuthServer = window.applicationConfig.platAuthUrl
serverUrl.mpServer = '/nngy'


// serverUrl.mpServerOrign = 'http://' + location.host + '/xjby'
